const initializeFormModal = () => {
  function onClick(event) {
    console.log("rsgfrsrf");
    if (event.target === dialog) {
      dialog.close();
    }
  }

  const dialog = document.querySelector(".pinned-contact-form-dialog");

  if (dialog) {
    console.log(dialog);
    dialog.addEventListener("click", onClick);
  }
};

if (document.readyState !== "loading") {
  initializeFormModal();
} else {
  document.addEventListener("DOMContentLoaded", initializeFormModal);
}
